<template>
	<div class="container-fluid px-lg-2 px-xl-4">
		<!-- Encabezado de ubicación (Breadcum)-->
		<div class="row d-flex align-items-center">
			<div class="col-12 col-sm-7 pl-0">
				<nav aria-label="breadcrumb ">
					<ol class="breadcrumb pl-0">
						<li class="breadcrumb-item">Captura de pedidos</li>
						<li class="breadcrumb-item">Lista de pedido</li>
					</ol>
				</nav>
			</div>
			<!-- <pm-button-excel @togleMenu=redirect :rutaCargado="rutaCargado"></pm-button-excel> -->
		</div>

		<div class="d-none d-md-block">
			<div class="row bg-white">
				<div class="col-6 d-flex align-items-center textSizeTable">
					<i class="icon-trazado-1107 mr-2 fa-lg"></i>
					<a>Ordernar por:</a>
					<select @change="ordenar()" class="form-control mx-2 combo textSizeTable" v-model="orden">
						<option hidden value="0">Orden</option>
						<option value="1">Alfabético</option>
						<option value="2">Genérico</option>
						<option value="3">Precio Ascendente</option>
						<option value="4">Precio Descendente</option>
					</select>
				</div>
				<div class="col-6 d-flex align-items-center justify-content-end textSizeTable">
					<img src="@/assets/img-priv/sustituto.png" style="width:15px; height:15px" />
					<a class="mx-3">Sustitutos</a>
					<a class="mx-3">US:Última Surtida</a>
					<a class="mx-3">UN:Última Negada</a>
				</div>
			</div>
		</div>
		<div class="d-block d-md-none">
			<div class="row my-4 py-2 bg-white">
				<div class="col-12 d-flex align-items-center textSizeTable">
					<i class="icon-trazado-1107 mr-2 fa-lg"></i>
					<select @change="ordenar()" class="form-control mx-2 combo textSizeTable" v-model="orden">
						<option hidden value="0">Orden</option>
						<option value="1">Alfabético</option>
						<option value="2">Fórmula</option>
						<option value="3">Precio Ascendente</option>
						<option value="4">Precio Descendente</option>
					</select>
				</div>
			</div>
		</div>

		<b-table	:fields="fields"
					:items="resultadosMostrar"
					class="mt-3 row"
					hover
					id="my-table"
					ref="tablaListaPedido"
					responsive
					small
					sticky-header="700px"
					table-class="bg-white"
				>
			<!--columna para xs-sm--(todo en una sola columna)-->
			<template v-slot:cell(x)="data">
				<div class="row">
					<div class="col-2 d-flex align-items-center">
						<div style="width:25px;">
							<img
								@click="mostrarSustitutos(data.item)"
								class="img-sustituto mr-2"
								src="@/assets/img-priv/sustituto.png"
								v-if="data.item.tieneSustituto"
							/>
						</div>
						<div style="width:25px;">
							<img
								src="@/assets/img-priv/Genérico para carta producto.png"
								style="width:20px;"
								v-show="data.item.gi"
							/>
						</div>
					</div>
					<div class="col-10 textSizeTable">
						<div class="row">
							<div class="col">
								<a style="fontWeight:bold;">{{data.item.descripcion}}</a>
							</div>
						</div>
						<div class="row">
							<div class="col mt-2">
								<a class="mr-1" style="fontWeight:Normal;">Colectivo:</a>
								{{data.item.empColectivo}}
							</div>
						</div>
						<div class="row my-1">
							<div class="col">
								<a class="mr-1" style="fontWeight:Normal;">Existencia {{usuarioGlobal().sucursal}}:</a>
								{{data.item.existenciaMiCedis}}
							</div>
							<div class="col">
								<a class="mr-1" style="fontWeight:Normal;">Otros CEDIS:</a>
								{{data.item.existenciaOtrosCedis}}
							</div>
						</div>
						<div class="row">
							<div class="col-4">
								<div class="d-flex justify-content-end" style="fontWeight:Normal;">Precio neto:</div>
								<div class="d-flex justify-content-end">{{data.item.precioNeto | format-number("0,0.00")}}</div>
							</div>
							<div class="col-4">
								<div class="d-flex justify-content-end" style="fontWeight:Normal;">Importe:</div>
								<div class="d-flex justify-content-end">
									{{data.item.precioNeto*data.item.cantidad | format-number("0,0.00")}}
								</div>
							</div>
							<div class="col-4">
								<div class="row">
									<input
										:ref="'cantidad_'+data.item.codArticulo"
										@blur="agregarCantidad(data.item, $event.target.value)"
										@keyup.enter="agregarCantidad(data.item, $event.target.value)"
										class="form-control styleCantidad"
										maxlength="5"
										oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
										onkeydown="if(event.key==='.'){event.preventDefault();}"
										type="text"
										v-model="data.item.textCantidad"
									/>
									<img class="icon-mas" src="@/assets/img-priv/mas.png" v-show="data.item.cantidad===0" />
									<img
										:src="mostrarImagenOver(data.item.x)"
										@click="quitarCantidad(data.item)"
										@mouseleave="data.item.x = false"
										@mouseover="data.item.x = true"
										class="icon-palomita"
										v-show="data.item.cantidad > 0"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>

			<!--columna para md(Descripcion)-->
			<template v-slot:cell(textCantidad)="data">
				<div class="row">
					<div class="col-2 d-flex align-items-center">
						<div style="width:25px;">
							<img
								@click="mostrarSustitutos(data.item)"
								class="img-sustituto mr-2"
								src="@/assets/img-priv/sustituto.png"
								v-if="data.item.tieneSustituto"
							/>
						</div>
						<div style="width:25px;">
							<img
								src="@/assets/img-priv/Genérico para carta producto.png"
								style="width:20px;"
								v-show="data.item.gi"
							/>
						</div>
					</div>
					<div class="col-10 textSizeTable">
						<div class="row">
							<div class="col">
								<a style="fontWeight:bold;">{{data.item.descripcion}}</a>
								<br />
								<div class="ml-2">{{data.item.formula}}</div>
							</div>
						</div>
						<div class="row">
							<div class="col">
								<a style="fontWeight:Normal;">Colectivo:</a>
								{{data.item.empColectivo}}
							</div>
						</div>
						<div class="row">
							<div class="col-6">
								<a style="fontWeight:Normal;">Existencia {{usuarioGlobal().sucursal}}:</a>
								{{data.item.existenciaMiCedis}}
							</div>
							<div class="col-6">
								<a style="fontWeight:Normal;">Otros CEDIS:</a>
								{{data.item.existenciaOtrosCedis}}
							</div>
						</div>
					</div>
				</div>
			</template>

			<!--columna para lg-xl-->
			<template v-slot:cell(descripcion)="data">
				<div class="d-flex">
					<div class="text-center" style="width:10%!important;">
						<img
							@click="mostrarSustitutos(data.item)"
							class="img-sustituto mt-3"
							src="@/assets/img-priv/sustituto.png"
							v-show="data.item.tieneSustituto"
						/>
					</div>
					<div class="text-center" style="width:10%!important;">
						<img
							class="mt-3"
							src="@/assets/img-priv/Genérico para carta producto.png"
							style="width:18px;"
							v-show="data.item.gi"
						/>
					</div>
					<div
						@click="mostrarDetalle(data.item.codArticulo)"
						class="textSizeTable mt-2 ml-1 cursorHand"
						style="width:100%"
					>
						{{data.item.descripcion}}
						<br />
						<div class="ml-2">{{data.item.formula}}</div>
					</div>
				</div>
			</template>
			<template v-slot:cell(existenciaMiCedis)="data">
				<div class="textSizeTable">{{data.item.existenciaMiCedis | format-number("0,0")}}</div>
			</template>
			<template v-slot:cell(ExistenciaOtrosCedis)="data">
				<div class="textSizeTable">{{data.item.existenciaOtrosCedis | format-number("0,0")}}</div>
			</template>
			<template v-slot:cell(empColectivo)="data">
				<div class="textSizeTable">{{data.item.empColectivo | format-number("0,0")}}</div>
			</template>
			<template v-slot:cell(cantidad)="data">
				<div class="d-flex justify-content-end mt-1">
					<input
						:ref="'cantidad_'+data.item.codArticulo"
						@blur="agregarCantidad(data.item, $event.target.value)"
						@keyup.enter="agregarCantidad(data.item, $event.target.value)"
						class="form-control styleCantidad"
						maxlength="5"
						oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
						onkeydown="if(event.key==='.'){event.preventDefault();}"
						type="text"
						v-model="data.item.textCantidad"
					/>

					<img
						class="icon-mas"
						src="@/assets/img-priv/mas.png"
						v-show="data.item.cantidad==0 || data.item.cantidad==''"
					/>
					<img
						:src="mostrarImagenOver(data.item.x)"
						@click="quitarCantidad(data.item)"
						@mouseleave="data.item.x = false"
						@mouseover="data.item.x = true"
						class="icon-palomita"
						v-show="data.item.cantidad > 0"
					/>
				</div>
			</template>
			<template v-slot:cell(precioNeto)="data">
				<div class="textSizeTable">
					<div>{{data.item.precioNeto | format-number("0,0.00")}}</div>
				</div>
			</template>
			<template v-slot:cell(importe)="data">
				<div class="textSizeTable">
					<div>{{data.item.precioNeto*data.item.cantidad | format-number("0,0.00")}}</div>
				</div>
			</template>
			<template v-slot:cell(ultimoSurtido)="data">
				<div class="textSizeTable" v-show="data.item.ultimoSurtido>0">
					<div>{{data.item.ultimoSurtido | format-number("0,0")}}</div>
				</div>
			</template>
			<template v-slot:cell(ultimoNegado)="data">
				<div class="textSizeTable" v-show="data.item.ultimoNegado>0">
					<div>{{data.item.ultimoNegado | format-number("0,0")}}</div>
				</div>
			</template>
		</b-table>
		<div class="row" v-if="rows>0">
			<div class="col-12 pt-3 d-flex justify-content-center">
				<ul class="pagination">
					<li class="page-item " v-show="current_page > 1">
						<a @click="navegar(1)" class="page-link" role="button">«</a>
					</li>
					<li v-show="current_page > 1" class="page-item">
						<a
							@click="navegar(current_page-1)"
							class="page-link text-decoration-none d-none d-md-block"
							role="button"
						>Anterior</a>
					</li>
					<li :class="{active: current_page == pag}" :key="pag" class="page-item" v-for="pag in paginas">
						<a @click="navegar(pag)" class="page-link">{{pag}}</a>
					</li>
					<li class="page-item" v-show="current_page < numPages()">
						<a 	@click="navegar(current_page+1)" 
							class="page-link d-none d-md-block" 
							role="button">Siguiente</a>
					</li>
					<li class="page-item" v-show="current_page < numPages()">
						<a @click="navegar(numPages())" class="page-link" role="button">»</a>
					</li>
				</ul>
			</div>
			<!-- 
				<div class="col-12 pt-3 d-flex justify-content-center">
				<ul class="pagination">
					<li class="page-item" v-show="current_page > 1">
						<a @click="navegar(1)" class="page-link" role="button">«</a>
					</li>
					<li class="page-item" v-show="current_page > 1">
						<a	@click="prevPage" 
								class="page-link text-decoration-none">
								‹ Anterior
						</a>
					</li>

					<li :class="{active: current_page == pag}" :key="pag" v-for="pag in paginas">
						<a @click="navegar(pag)" class="page-link">{{pag}}</a>
					</li>

					<li class="page-item" v-show="current_page < numPages()">
						<a @click="nextPage" 
								class="page-link text-decoration-none ml-2">
								Siguiente ›
						</a>
					</li>
					<li class="page-item" v-show="current_page < numPages()">
						<a @click="navegar(numPages())" class="page-link" role="button">»</a>
					</li>
				</ul>
			</div> -->
				
			<!-- <b-pagination
				:per-page="perPage"
				:total-rows="rows"
				aria-controls="my-table"
				limit="5"
				next-text="Siguiente"
				prev-text="Anterior"
				v-model="currentPage"
			></b-pagination> -->
		</div>

		<Pm-Sustitutos
			:articulo="articuloSeleccionado"
			:sustitutos="sustitutos"
			@agregarCantidad="agregarCantidadSustituto"
			id="exampleModal"
		></Pm-Sustitutos>
	</div>
</template>

<script>
	import servicioMiListaPedidos from "@/services/servicio-mi-lista-pedidos"
	import servicioSustitutos from "@/services/servicio-detalle-producto"
	import PmSustitutos from "@/components/clientes/MiListaPedidoSustitutos"
	//import PmButtonExcel from "@/components/clientes/ButtonExcel"
	import servicio from "@/services/servicio-detalle-producto"

	export default {
		components: {
			PmSustitutos,
			//PmButtonExcel,
		},
		data() {
			return {
				//rutaCargado:'captura de pedido',
				articulos: [],
				orden: 0,
				articuloSeleccionado: null,
				sustitutos: [],
				sucursal: "culiacan",
				fields: [
					{
						key: "x",
						label: "Mi lista de pedido",
						thStyle: {
							background: "#335198",
							color: "#ffffff",
							fontSize: "17px",
							fontWeight: "Normal",
						},
						thClass: "d-block d-md-none font-14",
						tdClass: "d-block d-md-none",
					},
					{
						key: "textCantidad",
						label: "Nombre del producto",
						thStyle: {
							background: "#335198",
							color: "#ffffff",
							fontSize: "17px",
							fontWeight: "Normal",
						},
						thClass: "d-none d-md-table-cell d-lg-none font-14",
						tdClass: "d-none d-md-table-cell d-lg-none",
					},
					{
						key: "descripcion",
						label: "Nombre del producto",
						thStyle: {
							background: "#335198",
							color: "#ffffff",
							fontSize: "17px",
							fontWeight: "Normal",
						},
						thClass: "d-none d-lg-table-cell font-14",
						tdClass: "d-none d-lg-table-cell vertical-align-center",
					},
					{
						key: "existenciaMiCedis",
						label: "Existencia " + this.usuarioGlobal().sucursal, //  JSON.parse(window.localStorage.user).sucursal,
						thStyle: {
							background: "#335198",
							color: "#ffffff",
							fontSize: "17px",
							fontWeight: "Normal",
						},
						thClass: "d-none d-lg-table-cell text-right font-14",
						tdClass: "d-none d-lg-table-cell text-right vertical-align-center",
					},
					{
						key: "ExistenciaOtrosCedis",
						label: "Otros CEDIS",
						thStyle: {
							background: "#335198",
							color: "#ffffff",
							fontSize: "17px",
							fontWeight: "Normal",
						},
						thClass: "d-none d-lg-table-cell text-right font-14",
						tdClass: "d-none d-lg-table-cell text-right vertical-align-center",
					},
					{
						key: "empColectivo",
						label: "Colectivo",
						thStyle: {
							background: "#335198",
							color: "#ffffff",
							fontSize: "17px",
							fontWeight: "Normal",
						},
						thClass: "d-none d-lg-table-cell text-right font-14",
						tdClass: "d-none d-lg-table-cell text-right vertical-align-center",
					},
					{
						key: "cantidad",
						label: "Cantidad",
						thStyle: {
							background: "#335198",
							color: "#ffffff",
							fontSize: "17px",
							fontWeight: "Normal",
						},
						thClass: "d-none d-md-table-cell text-right font-14",
						tdClass: "d-none d-md-table-cell text-right vertical-align-center",
					},
					{
						key: "precioNeto",
						label: "Precio neto",
						thStyle: {
							background: "#335198",
							color: "#ffffff",
							fontSize: "17px",
							fontWeight: "Normal",
						},
						thClass: "d-none d-md-table-cell text-right font-14",
						tdClass: "d-none d-md-table-cell text-right vertical-align-center",
					},
					{
						key: "importe",
						label: "Importe",
						thStyle: {
							background: "#335198",
							color: "#ffffff",
							fontSize: "17px",
							fontWeight: "Normal",
						},
						thClass: "d-none d-md-table-cell text-right font-14",
						tdClass: "d-none d-md-table-cell text-right vertical-align-center",
					},
					{
						key: "ultimoSurtido",
						label: "US",
						thStyle: {
							background: "#335198",
							color: "#ffffff",
							fontSize: "17px",
							fontWeight: "Normal",
						},
						thClass: "d-none d-md-table-cell text-right font-14",
						tdClass: "d-none d-md-table-cell text-right vertical-align-center",
					},
					{
						key: "ultimoNegado",
						label: "UN",
						thStyle: {
							background: "#335198",
							color: "#ffffff",
							fontSize: "17px",
							fontWeight: "Normal",
						},
						thClass: "d-none d-md-table-cell text-right font-14",
						tdClass: "d-none d-md-table-cell text-right vertical-align-center",
					},
				],
				//totalRows: 0,
				//perPage: 20,
				//currentPage: 1,
				//totalRows: 0,
				resultadosMostrar: [],
				records_per_page: 20,
				current_page: 1,
				paginas:[],
				UUIDAcceso: '',
			}
		},
		computed: {
			rows() {
				return this.articulos.length
			},
		},
		mounted() {
			this.obtenerListaPedidos()
			this.carritoConsultarCantidad()
			this.obtenerNotificaciones()
			//console.log(this.usuarioGlobal())
		},
		methods: {
			redirect(){				
				this.$emit("togleMenu", 1);
			},
			scrollToTop() {
				window.scrollTo(0, 0);
			},
			mostrarDetalle(codArticulo) {
				//console.log(codArticulo)
				this.$router.push({
					path: `/clientes/detalle-producto/${codArticulo}`,
				})
			},
			mostrarSustitutos(item) {
				servicioSustitutos
					.productosSustitutos(item.codArticulo)
					.then((r) => {
						if (r.value) {
							this.articuloSeleccionado = item
							this.sustitutos = r.data
							this.$bvModal.show("modal-sustitutos")
						} else {
							this.articuloSeleccionado = item
							this.sustitutos = []
							this.$bvModal.show("modal-sustitutos")
						}
					})
					.catch((ex) => {
						console.log(ex)
					})
			},
			ordenar() {
				if (this.orden == 0 || this.orden == 1) {
					this.resultadosMostrar.sort((a, b) => {
						return a.descripcion > b.descripcion ? 1 : -1
					})
				} else if (this.orden == 2) {
					this.resultadosMostrar.sort((a, b) => {
						return a.formula > b.formula ? 1 : -1
					})
				} else if (this.orden == 3) {
					this.resultadosMostrar.sort((a, b) => {
						return a.precioNeto > b.precioNeto ? 1 : -1
					})
				} else if (this.orden == 3) {
					this.resultadosMostrar.sort((a, b) => {
						return a.precioNeto < b.precioNeto ? 1 : -1
					})
				}
			},
			mostrarImagenOver(borrar = false) {
				let imagenes = require.context("../../../assets/img-priv", false)
				if (borrar) return imagenes("./x.png")

				return imagenes("./palomita.png")
			},
			quitarCantidad(item) {
				item.cantidad = 0
				item.textCantidad = ""

				this.carritoModificarCantidad(item.codArticulo, item.cantidad)
			},
			async agregarCantidad(item, cantidad) {
				// console.log("cantidad: ", cantidad, typeof cantidad)

				if (this.isNumeric(cantidad)) {
					if (cantidad == 0) {
						item.textCantidad = ""
					}
					if (item.cantidad != cantidad) {
						item.cantidad = cantidad
						if(item.tipoControl == 1 && cantidad > 0){
							this.$msg.info( 'Producto refrigerado sin derecho a devolución.')
						}
						if(item.precioRemate > 0 && item.cantidad > 0){
							this.$msg.info( 'Producto de remate sin derecho a devolución.')
						}
						let token = ''
						if(window.localStorage.tokenDifarmer)
						{
							let lstoken = JSON.parse(window.localStorage.tokenDifarmer)
							token = lstoken.token;
						}

						await this.validarClickPublicidad(item.codArticulo, token)

						this.carritoModificarCantidad(item.codArticulo, cantidad,this.UUIDAcceso)
					}
				} else if (item.cantidad != 0) {
					item.cantidad = 0
					this.carritoModificarCantidad(item.codArticulo, 0)
				}
			},
			async agregarCantidadSustituto(item) {
				if (item.cantidad == 0) {
					item.textCantidad = ""
				} else {
					item.textCantidad = item.cantidad
					if(item.tipoControl == 1 && item.cantidad > 0){
						this.$msg.info( 'Producto refrigerado sin derecho a devolución.')
					}
					if(item.precioRemate > 0 && item.cantidad > 0){
						this.$msg.info( 'Producto de remate sin derecho a devolución.')
					}
				}
				let token = ''
				if(window.localStorage.tokenDifarmer)
				{
					let lstoken = JSON.parse(window.localStorage.tokenDifarmer)
					token = lstoken.token;
				}

				await this.validarClickPublicidad(item.codArticulo, token)

				this.carritoModificarCantidad(item.codArticulo, item.cantidad, this.UUIDAcceso)
			},
			isNumeric: function (n) {
				return !isNaN(parseFloat(n)) && isFinite(n)
			},
			obtenerListaPedidos() {
				this.$loading(true)
				servicioMiListaPedidos
					.obtenerListaPedidos()
					.then((r) => {
						this.$loading(false)
						this.articulos = r.data

						this.articulos.forEach((element) => {
							this.$set(element, "x", false)
						})

						this.orden = 0
						this.changePage()
						this.ordenar()
					})
					.catch((ex) => {
						console.log(ex)
						this.$loading(false)
					})
			},

			navegar(pagina){
				this.current_page = pagina
				this.changePage()

				this.$nextTick(() => {
					var containerBody  = this.$refs.tablaListaPedido
					//console.log("tabla", containerBody)
					if(this.resultadosMostrar.length > 0)
					{
						//console.log("scroll", containerBody.$el.scrollTop)
						this.scrollToTop()
						containerBody.$el.scrollTop = 0;
					}
				});					
			},
			changePage() {
				
				this.selectAll = false

				this.$nextTick(() => {
					this.resultadosMostrar = []
					this.inicio = this.current_page * this.records_per_page - this.records_per_page
					this.fin = this.current_page * this.records_per_page
					
					this.resultadosMostrar = this.articulos.slice(
						this.inicio,
						this.fin
					)

					this.paginadorBotones()
				})
			},
			paginadorBotones(){
				
				if (this.current_page == null || this.numPages() == null) return []

				let res = []
				const max = 5
				let aux = Math.floor(max / 2)

				let inicioPaginado = this.current_page - aux > 0 ? this.current_page - aux : 1

				let finPaginado = this.current_page + aux > this.numPages() ? this.numPages() : this.current_page + aux

				for (let i = inicioPaginado; i <= finPaginado; i++) {
					res.push(i)
				}

				this.paginas = res		
			},
			numPages() {
				return Math.ceil(this.articulos.length / this.records_per_page)
			},
			async validarClickPublicidad(codArticulo, token){
				let r = await servicio.validarClickPublicidad({"idProducto":codArticulo, "accessToken":token} )
				if (r.data){
					this.UUIDAcceso = r.data[0]
				}
			},
		},
	}
</script>

<style scoped>
	.cursorHand {
		cursor: pointer;
	}
	.img-sustituto {
		cursor: pointer;
	}
	.Titulo {
		font-family: "Open Sans";
		color: var(--bg-menu-blue);
		font-weight: bold;
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		.textSizeTable {
			font-size: 14px !important;
			color: var(--bg-menu-blue);
			font-weight: bold;
		}
		.styleCantidad {
			background: var(--bg-gray);
			width: 70px;
			border-top-left-radius: 30px;
			border-top-right-radius: 30px;
			border-bottom-left-radius: 30px;
			border-bottom-right-radius: 30px;
			font-weight: bold;
			color: var(--bg-menu-blue);
			font-size: 13px;
		}
		.icon-mas {
			position: relative;
			margin-left: -35px;
			height: 35px;
			cursor: pointer;
		}
		.icon-x {
			position: relative;
			margin-left: -35px;
			height: 35px;
			cursor: pointer;
		}
		.icon-palomita {
			position: relative;
			margin-left: -35px;
			height: 35px;
			cursor: pointer;
			background: url("/assets/img-priv/palomita.png") no-repeat;
			display: inline-block;
		}
		.combo {
			width: 100%;
			border: 1px solid var(--bg-menu-blue);
			color: var(--bg-menu-blue);
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		.textSizeTable {
			font-size: 14px !important;
			color: var(--bg-menu-blue);
			font-weight: bold;
		}
		.styleCantidad {
			background: var(--bg-gray);
			width: 70px;
			border-top-left-radius: 30px;
			border-top-right-radius: 30px;
			border-bottom-left-radius: 30px;
			border-bottom-right-radius: 30px;
			font-weight: bold;
			color: var(--bg-menu-blue);
			font-size: 14px;
		}
		.icon-mas {
			position: relative;
			margin-left: -35px;
			height: 36px;
			cursor: pointer;
		}
		.icon-x {
			position: relative;
			margin-left: -35px;
			height: 36px;
			cursor: pointer;
		}
		.icon-palomita {
			position: relative;
			margin-left: -35px;
			height: 36px;
			cursor: pointer;
			background: url("/assets/img-priv/palomita.png") no-repeat;
			display: inline-block;
		}
		.combo {
			width: 100%;
			border: 1px solid var(--bg-menu-blue);
			color: var(--bg-menu-blue);
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		.img-generico {
			width: 16px;
			height: 16px;
		}
		.textSizeTable {
			font-size: 12px !important;
			color: var(--bg-menu-blue);
			font-weight: bold;
		}
		.styleCantidad {
			background: var(--bg-gray);
			width: 70px;
			border-top-left-radius: 30px;
			border-top-right-radius: 30px;
			border-bottom-left-radius: 30px;
			border-bottom-right-radius: 30px;
			font-weight: bold;
			color: var(--bg-menu-blue);
			font-size: 12px;
		}
		.icon-mas {
			position: relative;
			margin-left: -30px;
			height: 33px;
			cursor: pointer;
		}
		.icon-x {
			position: relative;
			margin-left: -30px;
			height: 33px;
			cursor: pointer;
		}
		.icon-palomita {
			position: relative;
			margin-left: -30px;
			height: 33px;
			cursor: pointer;
			background: url("/assets/img-priv/palomita.png") no-repeat;
			display: inline-block;
		}
		.combo {
			width: 60%;
			border: 1px solid var(--bg-menu-blue);
			color: var(--bg-menu-blue);
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
		.img-generico {
			width: 16px;
			height: 16px;
		}
		.textSizeTable {
			font-size: 12px !important;
			color: var(--bg-menu-blue);
			font-weight: bold;
		}
		.styleCantidad {
			background: var(--bg-gray);
			width: 70px;
			border-top-left-radius: 30px;
			border-top-right-radius: 30px;
			border-bottom-left-radius: 30px;
			border-bottom-right-radius: 30px;
			font-weight: bold;
			color: var(--bg-menu-blue);
			font-size: 12px;
		}
		.icon-mas {
			position: relative;
			margin-left: -30px;
			height: 34px;
			cursor: pointer;
		}
		.icon-x {
			position: relative;
			margin-left: -30px;
			height: 34px;
			cursor: pointer;
		}
		.icon-palomita {
			position: relative;
			margin-left: -30px;
			height: 34px;
			cursor: pointer;
			background: url("/assets/img-priv/palomita.png") no-repeat;
			display: inline-block;
		}
		.combo {
			width: 60%;
			border: 1px solid var(--bg-menu-blue);
			color: var(--bg-menu-blue);
		}
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
		.textSizeTable {
			font-size: 13px !important;
			color: var(--bg-menu-blue);
			font-weight: bold;
		}
		.styleCantidad {
			background: var(--bg-gray);
			width: 70px;
			border-top-left-radius: 30px;
			border-top-right-radius: 30px;
			border-bottom-left-radius: 30px;
			border-bottom-right-radius: 30px;
			font-weight: bold;
			color: var(--bg-menu-blue);
			font-size: 14px;
		}
		.icon-mas {
			position: relative;
			margin-left: -30px;
			height: 36px;
			cursor: pointer;
		}
		.icon-x {
			position: relative;
			margin-left: -30px;
			height: 36px;
			cursor: pointer;
		}
		.icon-palomita {
			position: relative;
			margin-left: -30px;
			height: 36px;
			cursor: pointer;
			background: url("/assets/img-priv/palomita.png") no-repeat;
			display: inline-block;
		}
		.combo {
			width: 60%;
			border: 1px solid var(--bg-menu-blue);
			color: var(--bg-menu-blue);
		}
	}
</style>
